module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('span', {
    staticClass: "originator"
  }, [_vm._v(" " + _vm._s(_vm.getFullName) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "time pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.datetime, 'from', 'now')))])]), _vm._v(" "), _c('div', {
    staticClass: "message-content"
  }, [_vm._v(_vm._s(_vm.message))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar pull-left"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166e3042","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/MessageReply.vue
// module id = 3153
// module chunks = 3